import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";

import HelpTicket from "./CRUDs/entities/HelpTicket";

export default {
    init() {
        this.initForm();
        this.getMenu();
        this.training();
        this.loadSwitcherForDifferenceModal();
        //this.spylog();
        this.createTicketEvent();
        this.menusInit();
        this.getStartedActions();
    },
    initForm() {
        let $this = this;
        $('#time-management').on('change', 'select', function (e) {
            $this.updateTimeManagementTable(e);
        });
        $("#start_date").on("dp.change", function (e) {
            $this.updateTimeManagementTable(e);
        });
        $("#end_date").on("dp.change", function (e) {
            $this.updateTimeManagementTable(e);
        });
    },
    updateTimeManagementTable(e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: '/update_time_management_table',
            data: $('#time-management-form').serialize(),
            success: function (response) {
                $('#dashboard .time-management-table').html(response.times);
            }
        });
    },
    getMenu() {

        $('body').on('click', '.cockpit-admin #main-menu', function(e) {

            e.preventDefault();
            $('#main-menu-modal').modal('show');

            jQuery(function () {
                $.ajax({
                    type: 'GET',
                    url: '/admin/get-menu',
                    success: function (response) {
                        $('#main-menu-modal .modal-body').html(response);
                    },
                });
            });
        });
    },
    training() {
        /* $('body').on('click', '#dashboard .skip-training', function(e) {
            $('#dashboard .training').css('display', 'none');
            $('#dashboard .show-training').toggleClass(['d-flex', 'd-none']);
            $.ajax({
                type: 'POST',
                url: '/skip-training',
                data: ({}),
            });
        });
        $('body').on('click', '#dashboard .show-training', function(e) {
            $('#dashboard .training').css('display', 'block');
            $('#dashboard .show-training').toggleClass(['d-flex', 'd-none']);
        });*/
        /* $('body').on('click', '#dashboard .show_video_modal', function(e) {
            $('#video_training_modal').modal('show')
        }); */
        $('body').on('click', '#dashboard .hide-completed', function(e) {
            $($('.fa-ellipse-check').closest('.training-task-container')).toggleClass(['d-flex', 'd-none']);
        });

        $('body').on('click', '#dashboard .show-training', function(e) {
            let name = $(this).data('name');
            $('#dashboard .training-container.'+name).toggleClass(['hide', 'show mt-25']);
            if ($(this).find('u').text() == 'Show Training') {
                $(this).find('u').text('Skip Training');
            } else {
                $(this).find('u').text('Show Training');
            }
            if ($('#dashboard .training-container.'+name).hasClass('jobs')) {
                $('#dashboard .training-container.'+name).toggleClass('pt-0');
            }
        });
    },
    loadSwitcherForDifferenceModal(){
        $(document).off('show.bs.modal', '#difference_modal')
            .on('show.bs.modal', '#difference_modal', ()=>{
                setTimeout(()=>{
                    let switcher = document.querySelector('#difference_modal .switcher');
                    new SimpleSectionSwitcher(switcher)
                    switcher.addEventListener('afterswitch', e =>{
                        const mainTitle = document.querySelector('#difference_modal #main-title')
                        const addTitle = document.querySelector('#difference_modal #add-title')
                        mainTitle.textContent = e.detail.button.textContent
                        addTitle.textContent = e.detail.button.getAttribute('data-add-title')
                    })
                },100)
            })
    },
    watchTicketForm() {
        $('#submit_help_ticket_form').on("submit", function(e) {
            e.preventDefault();
            var form = new FormData($(this)[0]);
            var actionUrl = $(this).attr('action');

            $.ajax({
                type: "POST",
                url: actionUrl,
                processData: false,
                contentType: false,
                data: form,
                success: function() {
                    $('#submit_help_ticket_form')[0].reset();
                    $('#help-confirmation-modal').modal('show');
                    $('#ticket-form-modal').modal('hide');
                    $('#take_screenshot_ticket').css("display", "block");
                    $('#take_screenshot_ticket_attached').css("display", "none");
                },
                error: function (response) {
                    if (response.responseJSON.error) {
                        $('#ticket-form-modal .form-validation-errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                    }
                    if (response.responseJSON.errors) {
                        let errorsHtml = '<div class="alert alert-danger">Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errorsHtml += '<li>' + value + '</li>';
                        });
                        errorsHtml += '</ul></div>';

                        $('#ticket-form-modal .form-validation-errors').html(errorsHtml);
                    }
                }
            });

            return false;
        });
    },
    createTicketEvent() {
        $('body').on('click', '#open_help_ticket_form', (e) => {
            $("#help-modal").modal("hide");
            const help_ticket = new HelpTicket();
            help_ticket.openModal('create');
        });
    },
    spylog() {
        console.everything = [];

        console.defaultLog = console.log.bind(console);
        console.log = function(){
            console.everything.push({"type":"log", "datetime":new Date().toISOString(), "value":Array.from(arguments)});
            console.defaultLog.apply(console, arguments);
        }
        console.defaultError = console.error.bind(console);
        console.error = function(){
            console.everything.push({"type":"error", "datetime":new Date().toISOString(), "value":Array.from(arguments)});
            console.defaultError.apply(console, arguments);
        }
        console.defaultWarn = console.warn.bind(console);
        console.warn = function(){
            console.everything.push({"type":"warn", "datetime":new Date().toISOString(), "value":Array.from(arguments)});
            console.defaultWarn.apply(console, arguments);
        }
        console.defaultDebug = console.debug.bind(console);
        console.debug = function(){
            console.everything.push({"type":"debug", "datetime":new Date().toISOString(), "value":Array.from(arguments)});
            console.defaultDebug.apply(console, arguments);
        }

        window.addEventListener('error',(e) => {
            if(e.isTrusted)
                console.everything.push({"type":"error", "datetime":new Date().toISOString(), "value":Array.from([e.message, e.stack])});
        });
    },

    menusInit(){
        $('#switch-company-btn').click(function(e) {
            e.preventDefault();
            $('.switch-company-menu').toggleClass('d-none');
            $(this).toggleClass(['open', 'closed']);
            if ($(this).hasClass('open')) {
                $(this).find('img').css('rotate','180deg');
            }else{
                $(this).find('img').css('rotate','');
            }
            if ($('.switch-company-menu').hasClass('dynamic')) {
                let posX, posY;
                posX = $(this).position().left + $(this).width() - $('.switch-company-menu').width();
                posY = $(this).position().top + $(this).height() + 20;
                console.log(posX, posY);

                $('.switch-company-menu').css({left: posX, top: posY});
            }
        });

        /* $('#account-menu-btn').click(function(e) {
            e.preventDefault();
            $('.account-menu').toggleClass('d-none');
        }); */

    },

    getStartedActions(){
        $('.open-started-list').click(function() {
            $(this).toggleClass('opened');
            const parent = $(this).parents('.get-start-list-container');
            parent.find('.get-start-steps').toggleClass('hided');
        });
        $('.steps-nav-button').click(function() {
            if (!$(this).hasClass('active') && !$(this).hasClass('disabled')) {
                const parent = $(this).parents('.get-start-steps');
                parent.find('.steps-nav-button').removeClass('active');
                $(this).addClass('active');

                let section = $(this).data('section');
                parent.find('.steps-container').removeClass('active');
                parent.find(`.steps-container.${section}`).addClass('active');
            }
        });

        $('.show-training').click(function() {
            let section = $(this).data('section');
            if (!$(`.steps-nav-button.${section}`).hasClass('disabled')) {
                $('.steps-nav-button').removeClass('active');
                $(`.steps-nav-button.${section}`).addClass('active');
                $('.steps-container').removeClass('active');
                $(`.steps-container.${section}`).addClass('active');
                $('.open-started-list').addClass('opened');
                $('.get-start-steps').removeClass('hided');
            }
        });

        $('.steps-nav-button.disabled').on('mouseover', function(e) {
            let section = $(this).data('section');
            let needed_plan = $(this).data('needed-plan');
            $('.blocked-info-window').find('.needed-plan').text(needed_plan+' plan');
            let posX = $(this).position().left + $(this).width()/10;
            if ($(this).width() < $(`.blocked-info-window`).width()) {
                posX = $(this).position().left - ($('.blocked-info-window').width() - $(this).width());
            }
            let posY = $(this).position().top - 80;
            $('.blocked-info-window').show();
            $('.blocked-info-window').css({left: posX, top: posY});
        });
        $('.steps-nav-button.disabled').on('mouseout', function(e) {
            $('.blocked-info-window').hide();
        });
        $('.steps-container .step-control button, .bar-control button').click(function(e) {
            e.preventDefault();
            const link = $(this).data('link');
            // location.href = link;
            window.open(link, '_blank');
        });
    }
}
